import React from "react";

export default function MobileRecordList({
  children,
  loading,
  empty,
  emptyText = "No data found",
  loadingText = "Loading…",
  footer,
  doneText,
  className = "",
  scrollRef,
  onScroll,
  style,
}) {
  return (
    <div
      ref={scrollRef}
      className={`pr-mobile-list ${className}`.trim()}
      onScroll={onScroll}
      style={style}
    >
      {children}
      {loading && (
        <div className="pr-mobile-list__loading">{loadingText}</div>
      )}
      {empty && !loading && (
        <div className="pr-mobile-list__empty">{emptyText}</div>
      )}
      {doneText && !loading && (
        <div className="pr-mobile-list__done">{doneText}</div>
      )}
      {footer && <div className="pr-mobile-list__actions">{footer}</div>}
    </div>
  );
}
